import React, {useState} from 'react';
import {Checkbox, Col, DatePicker, Input, InputNumber, message, Modal, Radio, Row, Select, Switch, Tag} from 'antd';
import dayjs from "dayjs";
import {stringToArray} from "../../_helpers/stringToArray";
import {calculateTotal} from "../../_helpers/calculateTotal";
import style from '../styles/expenses.periodic.module.css'

const {Option} = Select;

const AddPeriodicExpenseModal = ({
                                     visible,
                                     onCancel,
                                     onSave,
                                     categories,
                                     title = "Добавить периодический расход",
                                     initialValues,
                                 }) => {

    const defaultData = {
        name: initialValues ? initialValues.name : '',
        description: initialValues ? initialValues.description : '',
        category: initialValues ? initialValues.category : null,
        periodType: initialValues ? initialValues.schedule.type : "monthly",
        daysOfWeek: initialValues ? stringToArray(initialValues.schedule.daysOfWeek) : null,
        dateOfStart: initialValues ? dayjs(initialValues.schedule.dateOfStart) : dayjs(),
        dateOfEnd: initialValues ? initialValues.schedule.dateOfEnd ? dayjs(initialValues.schedule.dateOfEnd) : null : null,
        time: initialValues ? initialValues.time : '00:00',
        amount: initialValues ? initialValues.amount : null,
        paymentType: initialValues ? initialValues.isCash : true,
        tax: initialValues ? initialValues.tax : 21,
        isActive: initialValues ? initialValues.isActive : true,
        month: initialValues ? initialValues.schedule.month : null,
        day: initialValues ? initialValues.schedule.day : null,
    }

    const defaultValidate = {
        name: true,
        category: true,
        periodType: true,
        daysOfWeek: true,
        dateOfStart: true,
        time: true,
        amount: true,
        paymentType: true,
        tax: true,
        isActive: true,
        month: true,
        day: true,
    }

    const [data, setData] = useState(defaultData);
    const [validate, setValidate] = useState(defaultValidate);
    const [inputMode, setInputMode] = useState('withoutTax');
    const [zeroTaxChecked, setZeroTaxChecked] = useState(initialValues?.tax === 0);

    const calculateAmountWithoutTax = (amountWithTax, taxRate) => {
        if (!amountWithTax || taxRate === 0) return amountWithTax;
        return amountWithTax / (1 + taxRate / 100);
    };

    const calculateAmountWithTax = (amountWithoutTax, taxRate) => {
        if (!amountWithoutTax || taxRate === 0) return amountWithoutTax;
        return amountWithoutTax * (1 + taxRate / 100);
    };

    const updateData = (field, value) => {
        const newData = {...data, [field]: value};
        setData(newData);
    }

    const handleAmountChange = (value) => {
        const newValue = value === null || value === undefined ? null : value;
        let newAmount = newValue;
        if (inputMode === 'withTax') {
            newAmount = newValue !== null ? calculateAmountWithoutTax(newValue, data.tax) : null;
        }
        updateData('amount', newAmount);
    };

    const handleTaxChange = (value) => {
        if (zeroTaxChecked) {
            updateData('tax', 0);
        } else {
            updateData('tax', value);
        }
    };

    const handleModeChange = (checked) => {
        const newMode = checked ? 'withTax' : 'withoutTax';
        setInputMode(newMode);
    };

    const handleZeroTaxChange = (e) => {
        const isChecked = e.target.checked;
        setZeroTaxChecked(isChecked);
        if (isChecked) {
            updateData('tax', 0);
        } else {
            updateData('tax', 21);
        }
    };

    const getDisplayAmount = () => {
        if (inputMode === 'withTax') {
            return data.amount !== null ? calculateAmountWithTax(data.amount, data.tax) : null;
        }
        return data.amount;
    };


    // Вычисляем итоговую сумму для отображения
    const calculateFinalAmount = () => {
        if (!data.amount) return '0.00';
        if (data.paymentType) {
            return data.amount.toFixed(2);
        } else {
            if (data.tax === 0) {
                return data.amount.toFixed(2);
            }
            return calculateTotal(data.amount, data.tax, false).toFixed(2);
        }
    };

    const findCategoryById = (id) => {
        return categories.find(cat => String(cat.id) === String(id));
    };

    const CategoryDisplay = ({value}) => {
        const category = findCategoryById(value);
        if (!category) {
            return <span>Выберите категорию</span>;
        }
        return <Tag color={category.color}>{category.name}</Tag>;
    };

    const validateData = (formData) => {
        const newValidate = {...validate};
        let isValid = true;

        if (!formData.name || formData.name.trim() === '') {
            newValidate.name = false;
            isValid = false;
        } else {
            newValidate.name = true;
        }

        if (!formData.category_id || formData.category_id === '') {
            newValidate.category = false;
            isValid = false;
        } else {
            newValidate.category = true;
        }

        if (!formData.schedule_type || formData.schedule_type === '') {
            newValidate.periodType = false;
            isValid = false;
        } else {
            newValidate.periodType = true;
        }

        if (formData.schedule_type === 'weekly') {
            if (!formData.schedule_days_of_week || formData.schedule_days_of_week.length === 0) {
                newValidate.daysOfWeek = false;
                isValid = false;
            } else {
                newValidate.daysOfWeek = true;
            }
        } else {
            newValidate.daysOfWeek = true;
        }

        if (!formData.date_start || formData.date_start === '') {
            newValidate.dateOfStart = false;
            isValid = false;
        } else {
            newValidate.dateOfStart = true;
        }

        if (!formData.time_of_day || formData.time_of_day === '') {
            newValidate.time = false;
            isValid = false;
        } else {
            newValidate.time = true;
        }

        if (!formData.amount || formData.amount <= 0) {
            newValidate.amount = false;
            isValid = false;
        } else {
            newValidate.amount = true;
        }

        newValidate.paymentType = true;

        if (formData.isCash === false) {
            if (formData.tax_rate === undefined || formData.tax_rate === null || formData.tax_rate < 0) {
                newValidate.tax = false;
                isValid = false;
            } else {
                newValidate.tax = true;
            }
        } else {
            newValidate.tax = true;
        }

        newValidate.isActive = true;

        if (formData.schedule_type === 'monthly' || formData.schedule_type === 'yearly') {
            if (!formData.schedule_day || formData.schedule_day < 1 || formData.schedule_day > 31) {
                newValidate.day = false;
                isValid = false;
            } else {
                newValidate.day = true;
            }
        } else {
            newValidate.day = true;
        }

        if (formData.schedule_type === 'yearly') {
            if (!formData.schedule_month || formData.schedule_month < 1 || formData.schedule_month > 12) {
                newValidate.month = false;
                isValid = false;
            } else {
                newValidate.month = true;
            }
        } else {
            newValidate.month = true;
        }

        setValidate(newValidate);
        return isValid;
    };

    const handleSubmit = () => {
        const formData = {
            id: data.id,
            name: data.name,
            description: data.description,
            category_id: data.category,
            amount: data.amount,
            isCash: data.paymentType,
            is_active: data.isActive,
            tax_rate: data.tax,
            schedule_type: data.periodType,
            date_start: dayjs(data.dateOfStart).format('DD.MM.YYYY'),
            date_end: data.dateOfEnd ? dayjs(data.dateOfEnd).format('DD.MM.YYYY') : null,
            time_of_day: data.time,
            schedule_day: data.day,
            schedule_month: data.month,
            schedule_days_of_week: data.daysOfWeek,
        };
        if (validateData(formData)) {
            onSave(formData);
        } else {
            message.error('Не заполнены обязательные поля');
        }
    };

    return (
        <Modal
            title={title}
            open={visible}
            onOk={handleSubmit}
            onCancel={onCancel}
            width={600}
            okText="Сохранить"
            cancelText="Отмена"
            forceRender={true}
        >
            <div className={style.name_field}><span style={{color: 'red'}}>*</span> Наименование</div>
            <Input placeholder="Введите наименование расхода"
                   value={data.name}
                   onChange={v => updateData('name', v.target.value)}
                   status={!validate.name ? 'error' : 'success'}
            />

            <div className={style.name_field}><span style={{marginLeft: '10px'}}>Описание статьи расходов</span></div>
            <Input placeholder="Введите описание статьи расходов (не обязательно)" value={data.description}
                   onChange={v => updateData('description', v.target.value)}/>

            <div className={style.name_field}><span style={{color: 'red'}}>*</span> Категория</div>
            <Select placeholder="Выберите категорию расходов"
                    options={categories.map(category => ({value: +category.id, label: category.name}))}
                    defaultValue={data.category}
                    optionRender={option => (
                        <CategoryDisplay value={option.value}/>
                    )}
                    onChange={v => updateData('category', v)}
                    style={{width: '100%'}}
                    status={!validate.category ? 'error' : 'success'}
            />

            <div className={style.name_field}><span style={{color: 'red'}}>*</span> Периодичность</div>
            <Select style={{width: '100%'}}
                    placeholder="Выберите периодичность списания"
                    defaultValue={data.periodType}
                    onChange={v => updateData('periodType', v)}
                    status={!validate.periodType ? 'error' : 'success'}
            >
                <Option value="daily">Ежедневно</Option>
                <Option value="weekly">Еженедельно</Option>
                <Option value="monthly">Ежемесячно</Option>
                <Option value="yearly">Ежегодно</Option>
            </Select>

            {data.periodType === 'weekly' && <>
                <div className={style.name_field}><span style={{color: 'red'}}>*</span> Дни недели</div>
                <Select
                    mode="multiple"
                    placeholder="Укажите дни списания в течение недели"
                    style={{width: '100%'}}
                    defaultValue={data.daysOfWeek}
                    onChange={v => updateData('daysOfWeek', v)}
                    status={!validate.daysOfWeek ? 'error' : 'success'}

                >
                    {['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'].map((day, idx) => (
                        <Option key={idx} value={idx + 1}>{day}</Option>
                    ))}
                </Select>
            </>}

            {data.periodType === 'monthly' && <>
                <div className={style.name_field}><span style={{color: 'red'}}>*</span> Число месяца</div>
                <Select placeholder="Укажите число в которое будет выполняться списание"
                        style={{width: '100%'}}
                        defaultValue={data.day}
                        onChange={v => updateData('day', v)}
                        status={!validate.day ? 'error' : 'success'}
                >
                    {Array.from({length: 31}, (_, i) => i + 1).map(day => (
                        <Option key={day} value={day}>{day}</Option>
                    ))}
                </Select>
            </>}

            {data.periodType === 'yearly' && <div className={style.cont_of_period}>
                <div style={{width: '40%'}}>
                    <div className={style.name_field}><span style={{color: 'red'}}>*</span> Выберите месяц</div>
                    <Select placeholder="Укажите месяц списания"
                            defaultValue={data.month}
                            onChange={v => updateData('month', v)}
                            status={!validate.month ? 'error' : 'success'}
                            style={{width: '100%'}}
                    >
                        {Array.from({length: 12}, (_, i) => i + 1).map(month => (
                            <Option key={month} value={month}>{month}</Option>
                        ))}
                    </Select>
                </div>

                <div style={{width: '40%'}}>
                    <div className={style.name_field}><span style={{color: 'red'}}>*</span> Число месяца</div>
                    <Select placeholder="Укажите число списания"
                            defaultValue={data.day}
                            onChange={v => updateData('day', v)}
                            status={!validate.day ? 'error' : 'success'}
                            style={{width: '100%'}}
                    >
                        {Array.from({length: 31}, (_, i) => i + 1).map(day => (
                            <Option key={day} value={day}>{day}</Option>
                        ))}
                    </Select>
                </div>
            </div>}

            <div className={style.cont_of_dates}>
                <div>
                    <div className={style.name_field}><span style={{color: 'red'}}>*</span> Дата начала периода</div>
                    <DatePicker format="DD.MM.YYYY"
                                style={{width: '100%'}}
                                defaultValue={data.dateOfStart}
                                onChange={date => updateData('dateOfStart', date)}
                                status={!validate.dateOfStart ? 'error' : 'success'}
                    />
                </div>

                <div>
                    <div className={style.name_field}><span style={{marginLeft: '10px'}}>Дата окончания периода</span>
                    </div>
                    <DatePicker format="DD.MM.YYYY"
                                style={{width: '100%'}}
                                defaultValue={data.dateOfEnd}
                                onChange={date => updateData('dateOfEnd', date)}/>
                </div>
                <div>
                    <div className={style.name_field_type2}><span style={{marginLeft: '10px'}}>Время списания</span>
                    </div>
                    <Input style={{width: '100%'}} type="time" value={data.time}
                           onChange={v => updateData('time', v.target.value)}
                           status={!validate.time ? 'error' : 'success'}
                    />
                </div>
            </div>

            <div className={style.name_field}><span style={{color: 'red'}}>*</span> Тип платежа</div>
            <Radio.Group
                onChange={e => updateData('paymentType', e.target.value)}
                value={data.paymentType}>
                <Radio value={true}>Наличный</Radio>
                <Radio value={false}>Безналичный</Radio>
            </Radio.Group>

            {!data.paymentType && (
                <>
                    <div style={{marginBottom: '16px'}}>
                        <div className={style.name_field}>Данный платеж без НДС?</div>
                        <Checkbox
                            checked={zeroTaxChecked}
                            onChange={handleZeroTaxChange}
                        >
                            без НДС
                        </Checkbox>
                    </div>
                    {!zeroTaxChecked &&
                        <div style={{marginTop: '16px', marginBottom: '8px'}}>
                            <div className={style.name_field}>Вы хотите указать цену с НДС или без?</div>
                            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                <Switch
                                    checked={inputMode === 'withTax'}
                                    onChange={handleModeChange}
                                    checkedChildren="С НДС"
                                    unCheckedChildren="Без НДС"
                                />
                            </div>
                        </div>}
                </>
            )}

            <div className={style.cont_of_ammount}>
                <div style={{marginRight: '10px', flex: 1}}>
                    <div className={style.name_field}>
                        <span style={{color: 'red'}}>*</span>
                        {data.paymentType && 'Сумма'}
                        {zeroTaxChecked && 'Сумма'}
                        {!data.paymentType && inputMode === 'withTax' && !zeroTaxChecked && 'Сумма с НДС'}
                        {!data.paymentType && inputMode !== 'withTax' && !zeroTaxChecked && 'Сумма без НДС'}
                    </div>
                    <InputNumber
                        min={0}
                        step={0.01}
                        value={getDisplayAmount()}
                        status={!validate.amount ? 'error' : 'success'}
                        onChange={handleAmountChange}
                        style={{width: '100%'}}
                        parser={(value) => {
                            if (!value) return null;
                            return parseFloat(value.replace(',', '.'));
                        }}
                    />
                    {!data.paymentType && inputMode === 'withTax' && data.amount && (
                        <div style={{marginTop: '4px', fontSize: '12px', color: '#666'}}>
                            Без НДС: € {data.amount.toFixed(2)}
                        </div>
                    )}
                </div>

                <div>
                    {!data.paymentType &&
                        <>
                            <div className={style.name_field}><span style={{color: 'red'}}>*</span> НДС</div>
                            <InputNumber
                                value={data.tax}
                                min={0}
                                max={100}
                                disabled={zeroTaxChecked} // Отключаем поле если НДС 0%
                                status={!validate.tax ? 'error' : 'success'}
                                step={0.1}
                                style={{width: '100%'}}
                                addonAfter="%"
                                onChange={handleTaxChange}
                                parser={(value) => {
                                    if (!value) return null;
                                    return parseFloat(value.replace(',', '.'));
                                }}
                            />
                        </>
                    }
                </div>
            </div>

            <div className={style.name_field}>
                <Row style={{marginBottom: 16, padding: '8px', background: '#d0f3ce', borderRadius: '4px'}}>
                    <Col span={12}>
                        {data.paymentType && <strong>Итого:</strong>}
                        {!data.paymentType && zeroTaxChecked && <strong>Итого:</strong>}
                        {!data.paymentType && !zeroTaxChecked && <strong>Итого с НДС:</strong>}
                    </Col>
                    <Col span={12} style={{textAlign: 'right'}}>
                        <strong>
                            € {calculateFinalAmount()}
                        </strong>
                    </Col>
                </Row>
                {!data.paymentType && zeroTaxChecked && (
                    <Row style={{marginBottom: 16, padding: '8px', background: '#fff3cd', borderRadius: '4px'}}>
                        <Col span={24} style={{textAlign: 'center', color: '#856404'}}>
                            <strong>⚠️ Безналичный платеж (НДС не начисляется)</strong>
                        </Col>
                    </Row>
                )}
            </div>

            <div className={style.name_field}><span
                style={{color: 'red'}}>*</span>{data.isActive ? ' Выключить' : ' Включить'} </div>
            <Checkbox checked={data.isActive}
                      onChange={e => updateData('isActive', e.target.checked)}>Активный</Checkbox>
        </Modal>
    );
};

export default AddPeriodicExpenseModal;